import { DefaultRenderPathResolver } from '../DefaultRenderPathResolver';
import { VtkGeometry3DPath } from './VtkGeometry3DRenderPath';
import { VtkVolume3DPath } from './VtkVolume3DRenderPath';
export function createDefaultVolume3DRenderPaths() {
    return [new VtkVolume3DPath(), new VtkGeometry3DPath()];
}
export function createVolume3DRenderPathResolver(paths = createDefaultVolume3DRenderPaths()) {
    return new DefaultRenderPathResolver(paths);
}
